import React from "react";
import Button from "../../../components/common/Button";

const NavTabs = ({ tabs, activeTab, onTabSelect }) => {
  return (
    <div className="cht-flex cht-justify-center sm:cht-justify-start cht-p-1 cht-bg-gray-200/50 cht-backdrop-blur-md cht-rounded-full cht-w-full sm:cht-w-fit cht-shadow-inner cht-overflow-x-auto cht-scrollbar-hide cht-whitespace-nowrap">
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          variant="tab"
          isActive={activeTab === tab.id}
          onClick={() => onTabSelect(tab.id)}
          className="cht-px-6 cht-py-2"
          isPill
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );
};

export default NavTabs;
